// İşlem kayıtları uçları. Liste ve özet yalnızca admin içindir; sayfa
// ziyareti bildirimi oturum açmış herkes için çalışır.
import api from "../api/api";

export const fetchActivityLogs = (params) =>
  api.get("/api/admin/activity-logs", { params }).then((res) => res.data);

export const fetchActivitySummary = () =>
  api.get("/api/admin/activity-logs/summary").then((res) => res.data);

export const reportPageView = (path, title) =>
  api.post("/api/activity/page-view", { path, title }).catch(() => {
    // Kayıt düşerse kullanıcı hiçbir şey fark etmemeli.
  });
